import React from 'react'
import styled from 'styled-components'
import { FormType } from '../types'

export type Props = {
  title: string
  formType: FormType
  children: React.ReactNode
}

const StyledStepFormContainer = styled.div<{ formType: FormType }>`
  padding-top: ${({ formType }) => formType === 'QUESTIONNAIRE' ? '2rem' : '0'};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const StyledTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 400;
  margin: .5rem 0;
  line-height: 1;

  @media ${props => props.theme.media.sm} {
    font-size: 1.75rem;
    margin: .625rem 0;
  }
`

const StyledTitleUnderline = styled.div`
  width: 40px;
  height: 1px;
  background-color: ${props => props.theme.members.colors.silver._50};
  margin-top: 10px;

  @media ${props => props.theme.media.sm} {
    margin-top: 19px;
  }
`

const StyledFormContainer = styled.div`
  padding-top: 2rem;
  width: 100%;
  min-height: 300px;
`

export const StyledStepForm: React.FC<Props> = (props) => {
  return (
    <StyledStepFormContainer formType={props.formType}>
      { props.formType === 'QUESTIONNAIRE' &&
        (
          <>
            <StyledTitle data-cy="step-form-title">{props.title}</StyledTitle>
            <StyledTitleUnderline />
          </>
        )
      }
      <StyledFormContainer>
        {props.children}
      </StyledFormContainer>
    </StyledStepFormContainer>
  )
}
